export default __webpack_public_path__ + "static/6-2f1f2d1d59eaf9c15f74ee9496c9973e.png";